var map = {
	"./modules/administrator/administrator-routing.module": [
		"./src/app/modules/administrator/administrator-routing.module.ts"
	],
	"./modules/agent/agent-routing.module": [
		"./src/app/modules/agent/agent-routing.module.ts"
	],
	"./modules/client/client-routing.module": [
		"./src/app/modules/client/client-routing.module.ts"
	],
	"./pages/public/auth/auth.module": [
		"./src/app/pages/public/auth/auth.module.ts",
		"pages-public-auth-auth-module"
	],
	"src/app/pages/administrator/dashboard/dashboard.module": [
		"./src/app/pages/administrator/dashboard/dashboard.module.ts",
		"src-app-pages-administrator-dashboard-dashboard-module"
	],
	"src/app/pages/agent/dashboard/dashboard.module": [
		"./src/app/pages/agent/dashboard/dashboard.module.ts",
		"src-app-pages-agent-dashboard-dashboard-module"
	],
	"src/app/pages/client/dashboard/dashboard.module": [
		"./src/app/pages/client/dashboard/dashboard.module.ts",
		"src-app-pages-client-dashboard-dashboard-module"
	],
	"src/app/pages/client/faq/faq.module": [
		"./src/app/pages/client/faq/faq.module.ts",
		"src-app-pages-client-faq-faq-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;